module.exports = __webpack_public_path__ + "img/logo-2.cb4e5821.svg";